/* eslint-disable max-len */
import React, {useEffect} from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';

import {disableScroll, enableScroll} from '../../helpers';

import styles from './index.module.css';

export default ({isOpen, setModal, children, isSecondary}) => {
  useEffect(() => {
    if (isOpen) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [isOpen]);

  const handleClose = () => {
    setModal({isOpen: false});
    enableScroll();
  };

  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <div className={styles.modal}>
      <div className={clsx(styles.modalContent, {[styles.secodary]: isSecondary})}>
        <div
          className={styles.closeButton}
          onClick={handleClose}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.7513 5.28651L14.7142 4.24902L10.0007 8.96432L5.28722 4.24904L4.25013 5.28653L8.96361 10.0018L4.24902 14.7182L5.28611 15.7557L10.0007 11.0393L14.7153 15.7557L15.7524 14.7182L11.0378 10.0018L15.7513 5.28651ZM14.7139 4.3436L15.6565 5.28651L10.943 10.0018L15.6576 14.7182L14.715 15.6611L14.7153 15.6614L15.6581 14.7182L10.9435 10.0018L15.657 5.28651L14.7142 4.34334L14.7139 4.3436ZM10.0004 10.9452L10.0002 10.945L5.28585 15.6611L5.28611 15.6614L10.0004 10.9452ZM5.28722 4.34336L10.0004 9.05837L10.0002 9.05863L5.28696 4.34363L5.28722 4.34336Z" fill="#212121" />
          </svg>
        </div>
        {children}
      </div>
      <div
        onClick={handleClose}
        className={styles.backDrop}
      />
    </div>
    , document.body);
};
